export default __webpack_public_path__ + "static/media/IG.62c07187.png";